import Select from '@/components/Select/Select'
import {FoodSort} from '@/lib/food/types'

import style from './StoreSorter.module.scss'

interface Props {
  sorter: FoodSort
  setSorter: MemoizedCallbackOrDispatch<FoodSort>
}

const FOOD_SORT_LABELS: Record<FoodSort, string> = {
  [FoodSort.Relevance]: 'Relevance',
  [FoodSort.Cheapest]: 'Cheapest',
  [FoodSort.Distance]: 'Distance',
  [FoodSort.Fastest]: 'Fastest',
  [FoodSort.Rating]: 'Rating',
}

const OPTIONS = Object.entries(FOOD_SORT_LABELS).map(([value, label]) => ({
  label,
  value: value as FoodSort,
}))

export default memo(function StoreSorter({sorter, setSorter}: Props) {
  return (
    <Select
      className={style.Select}
      buttonProps={{className: style.Button}}
      popoverProps={{className: style.Popover}}
      prefix={<span aria-hidden>Sort by:</span>}
      label='Sort by'
      options={OPTIONS}
      selectedItem={sorter}
      setSelectedItem={setSorter}
    />
  )
})
